import { useEffect, useState } from 'react'

export const useInputFieldHacks = (oneBasedIndex: number) => {
  const [inputNumberKey, setInputNumberKey] = useState(`${oneBasedIndex}`)

  useEffect(() => {
    setInputNumberKey(`${oneBasedIndex}`)
  }, [oneBasedIndex])

  /**
   * This is needed to force a re-render of the input so that the input value is updated.
   */
  const updateInputNumberKey = () => setInputNumberKey(prev => prev + 1)

  /**
   * Track if text selection is in progress to prevent unwanted section toggle
   */
  const [isTextSelecting, setIsTextSelecting] = useState(false)

  const handleInputMouseDown = () => {
    setIsTextSelecting(true)
  }

  const handleContainerClick = (onToggle: () => void) => {
    if (isTextSelecting) {
      setIsTextSelecting(false)
      return
    }
    onToggle()
  }

  const handleInputMouseUp = () => {
    // Small delay to ensure click event is processed first
    setTimeout(() => {
      setIsTextSelecting(false)
    }, 0)
  }

  return {
    handleInputMouseDown,
    handleContainerClick,
    handleInputMouseUp,
    isTextSelecting,
    inputNumberKey,
    updateInputNumberKey,
  }
}
